exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tbl[data-v-3066d5be]{height:400px;width:100%;overflow-y:auto}.box[data-v-3066d5be]{margin:0 15px 15px 15px}.title[data-v-3066d5be]{margin-top:1px}\n", ""]);

// exports
